export default __webpack_public_path__ + "static/media/boy1.0f7608f3.png";